<template>
  <section class="inner-section mall-service-section">
    <div class="inner-heading">
      <h2>客户服务 <small>/Service</small></h2>
    </div>
    <div class="mall-service-grid">
      <a href="#/help">
        <img src="@/assets/images/new-img/malls/help-icon.png" alt="帮助中心" />
        <h3>帮助中心</h3>
        <p>一站式采购全流程中的常见问题<br />以及详细解决方法</p>
      </a>
      <a href="javascript:void(0)">
        <img src="@/assets/images/new-img/malls/member-icon.png" alt="会员权益和规则" />
        <h3>会员权益&amp;规则</h3>
        <p>通过消费或充值提升会员等级<br />可享有不同的福利和特权</p>
      </a>
      <a href="https://material-page.yunshanmeicai.com/richText/1000158" target="_blank">
        <img src="@/assets/images/new-img/malls/after-sale-icon.png" alt="售后准则" />
        <h3>售后准则</h3>
        <p>采购全流程中涉及的商户利益<br />或者权益说明</p>
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: "MallService"
};
</script>

<style lang="scss" scoped>
.inner-section {
  box-sizing: border-box;
  padding: 54px clamp(28px, 7vw, 112px) 70px;
  background: #f7f8f7;
  font-size: 16px;
  line-height: 1.5;
}

.inner-heading {
  margin-bottom: 38px;
}

h2 {
  margin: 0;
  color: #242a31;
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", Arial, sans-serif;
  font-size: clamp(40px, 4.5vw, 68px);
  font-weight: 650;
  letter-spacing: -0.065em;
  line-height: 1.08;
}

h2 small {
  color: #727b87;
  font-size: 0.42em;
  font-weight: 400;
  letter-spacing: 0;
}

.mall-service-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.mall-service-grid a {
  box-sizing: border-box;
  padding: 25px 50px;
  border-right: 1px solid #e0e4df;
  color: inherit;
  text-align: center;
  text-decoration: none;
}

.mall-service-grid a:last-child {
  border-right: 0;
}

.mall-service-grid img {
  display: block;
  width: 76px;
  height: 76px;
  margin: 0 auto 22px;
  object-fit: contain;
}

h3 {
  margin: 0 0 14px;
  color: #242a31;
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC", Arial, sans-serif;
  font-size: 18px;
  font-weight: 500;
}

p {
  margin: 0;
  color: #727b87;
  font-size: 13px;
  line-height: 1.8;
}

@media (max-width: 720px) {
  .mall-service-grid {
    grid-template-columns: 1fr;
  }

  .mall-service-grid a {
    border-right: 0;
    border-bottom: 1px solid #e0e4df;
  }
}
</style>
